import {FC} from 'react'
import {MultiUserCrewForm} from './form/multi-user-crew'
import {MultiUserProvider} from '../../../hooks/limpieza/useMultiUser'

const MultiUserCrewPageWrapper: FC = () => {
  return (
    <MultiUserProvider>
      <MultiUserCrewForm />
    </MultiUserProvider>
  )
}

export default MultiUserCrewPageWrapper
